import * as Yup from 'yup';

export const vetChatPetBirthdateAddedSegmentSchema = Yup.object({
  event: Yup.string().required(),
  properties: Yup.object({
    birthday: Yup.string().required(),
  }).required(),
});

export type VetChatPetBirthdateAddedSchema =
  Yup.InferType<typeof vetChatPetBirthdateAddedSegmentSchema>;

export const vetChatPetBreedAddedSegmentSchema = Yup.object({
  event: Yup.string().required(),
  properties: Yup.object({
    breed: Yup.string().required(),
  }).required(),
});

export type VetChatPetBreedAddedSchema = Yup.InferType<typeof vetChatPetBreedAddedSegmentSchema>;

export const vetChatPetNameAddedSegmentSchema = Yup.object({
  event: Yup.string().required(),
  properties: Yup.object({
    name: Yup.string().required(),
  }).required(),
});

export type VetChatPetNameAddedSchema = Yup.InferType<typeof vetChatPetNameAddedSegmentSchema>;

export const vetChatPetWeightAddedSegmentSchema = Yup.object({
  event: Yup.string().required(),
  properties: Yup.object({
    weight: Yup.string().required(),
  }).required(),
});

export type VetChatPetWeightAddedSchema = Yup.InferType<typeof vetChatPetWeightAddedSegmentSchema>;
